// extracted by mini-css-extract-plugin
module.exports = {"doubleRow":"AddEditConnectionPanel_doubleRow__Ch_Jp"};